import { render, staticRenderFns } from "./motorcade-add-or-update.vue?vue&type=template&id=62060afe"
import script from "./motorcade-add-or-update.vue?vue&type=script&lang=js"
export * from "./motorcade-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./motorcade-add-or-update.vue?vue&type=style&index=0&id=62060afe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports